import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledVisitLocationAddress = styled.div`
   ${basicSmallTextStyle};
   color: ${(props) => props.theme.backgroundDark};
   &:hover {
      color: inherit;
   }
`;
StyledVisitLocationAddress.displayName = 'StyledVisitLocationAddress';
